import { Institution } from "types";
import { SET_INSTITUTION } from "../actions/institution";
import createReducer from "./createReducer";

const initialState: Institution = {};

export default createReducer<any>({
  initialState,
  successType: SET_INSTITUTION,
});
